module.exports = __webpack_public_path__ + "assets/img/3.2fd44131.png";